import { render, staticRenderFns } from "./add.vue?vue&type=template&id=c0f3b0fa&scoped=true&lang=html"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=c0f3b0fa&prod&lang=css"
import style1 from "./add.vue?vue&type=style&index=1&id=c0f3b0fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f3b0fa",
  null
  
)

export default component.exports